var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 284.1 102.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ef3e29;\n      }\n\n      .st1 {\n        fill: #004a8f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.43,26.61s-.01-.03-.01-.05c-.07-.23-.16-.45-.27-.65-.02-.03-.03-.06-.05-.08-.26-.43-.61-.79-1.04-1.04-.02-.01-.04-.03-.06-.04L57.62,5.47c-.95-.55-2.11-.55-3.06,0L21.18,24.74c-.95.55-1.53,1.56-1.53,2.65v38.55c0,1.09.58,2.1,1.53,2.65l33.38,19.27s0,0,0,0c.47.27,1,.41,1.53.41s1.06-.14,1.53-.41c0,0,0,0,0,0l33.39-19.27c.95-.55,1.53-1.56,1.53-2.65V27.39c0-.27-.05-.53-.11-.78ZM56.09,11.65l27.26,15.74-27.26,15.74-27.26-15.74,27.26-15.74ZM25.76,32.69l27.27,15.74v31.49l-27.27-15.74v-31.49ZM59.15,79.92v-31.49l27.28-15.75v31.5l-27.28,15.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22.71,
    cy: 27.53,
    r: 9.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.71,40.2c-6.99,0-12.67-5.69-12.67-12.67s5.69-12.67,12.67-12.67,12.67,5.69,12.67,12.67-5.69,12.67-12.67,12.67ZM22.71,20.97c-3.61,0-6.56,2.94-6.56,6.56s2.94,6.56,6.56,6.56,6.55-2.94,6.55-6.56-2.94-6.56-6.55-6.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 89.47,
    cy: 27.53,
    r: 9.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.47,40.2c-6.99,0-12.67-5.69-12.67-12.67s5.69-12.67,12.67-12.67,12.67,5.69,12.67,12.67-5.69,12.67-12.67,12.67ZM89.47,20.97c-3.61,0-6.56,2.94-6.56,6.56s2.94,6.56,6.56,6.56,6.55-2.94,6.55-6.56-2.94-6.56-6.55-6.56Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 56.09,
    cy: 85.21,
    r: 9.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.09,97.89c-6.99,0-12.67-5.69-12.67-12.67s5.69-12.67,12.67-12.67,12.67,5.69,12.67,12.67-5.69,12.67-12.67,12.67ZM56.09,78.66c-3.61,0-6.56,2.94-6.56,6.56s2.94,6.56,6.56,6.56,6.55-2.94,6.55-6.56-2.94-6.56-6.55-6.56Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.71,62.63c-11.24,0-20.39-9.14-20.39-20.39s9.14-20.39,20.39-20.39,20.39,9.15,20.39,20.39-9.14,20.39-20.39,20.39ZM256.71,29.41c-7.07,0-12.83,5.76-12.83,12.83s5.76,12.83,12.83,12.83,12.83-5.76,12.83-12.83-5.76-12.83-12.83-12.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.51,43.99c.12-.89.21-1.78.21-2.7,0-1.67-.23-3.29-.62-4.86-2.19-8.89-10.21-15.52-19.77-15.52s-17.59,6.63-19.78,15.52c-.38,1.56-.6,3.18-.6,4.86,0,.92.09,1.81.19,2.7,1.33,9.97,9.86,17.69,20.19,17.69,8.77,0,16.23-5.58,19.09-13.37h-8.38c-2.29,3.5-6.24,5.82-10.72,5.82-6.15,0-11.3-4.35-12.54-10.13h32.72ZM160.46,36.44c1.92-4.67,6.52-7.97,11.87-7.97s9.95,3.29,11.86,7.97h-23.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.9,41.29c0,1.68-.23,3.3-.6,4.86-2.19,8.9-10.21,15.53-19.78,15.53-11.24,0-20.38-9.14-20.38-20.39s9.14-20.38,20.38-20.38c8.77,0,16.23,5.58,19.1,13.36h-8.38c-2.3-3.49-6.24-5.81-10.73-5.81-7.07,0-12.82,5.75-12.82,12.82s5.75,12.83,12.82,12.83c5.36,0,9.95-3.3,11.87-7.98h-15.88v-7.56h24.2c.12.88.19,1.78.19,2.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "147.66 21.42 134.16 50.73 120.65 21.42 112.33 21.42 130.73 61.34 137.59 61.34 155.98 21.42 147.66 21.42"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.92,66.17v19.67h-2.72v-19.67h2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.11,85.84h-2.72l-10.92-15.66v15.66h-2.72v-19.69h2.72l10.92,15.63v-15.63h2.72v19.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.13,66.17l-7.85,19.67h-3.13l-7.85-19.67h2.89l6.54,16.96,6.53-16.96h2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.04,68.26v6.57h7.58v2.12h-7.58v6.77h8.47v2.12h-11.19v-19.69h11.19v2.12h-8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.19,85.84h-2.72l-10.92-15.66v15.66h-2.72v-19.69h2.72l10.92,15.63v-15.63h2.72v19.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.83,66.17v2.09h-5.67v17.58h-2.72v-17.58h-5.7v-2.09h14.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.53,84.75c-1.59-.86-2.85-2.05-3.77-3.58-.92-1.53-1.39-3.26-1.39-5.18s.46-3.64,1.39-5.18c.93-1.53,2.18-2.73,3.77-3.58,1.59-.86,3.35-1.28,5.28-1.28s3.72.43,5.31,1.28,2.84,2.05,3.76,3.57c.92,1.52,1.37,3.25,1.37,5.19s-.46,3.67-1.37,5.19c-.92,1.52-2.17,2.71-3.76,3.57-1.59.86-3.36,1.28-5.31,1.28s-3.69-.43-5.28-1.28ZM227.73,82.84c1.16-.64,2.08-1.55,2.75-2.74s1-2.56,1-4.12-.33-2.96-1-4.13c-.67-1.18-1.58-2.08-2.73-2.72-1.15-.64-2.47-.96-3.94-.96s-2.79.32-3.94.96c-1.15.64-2.06,1.55-2.73,2.72-.67,1.18-1,2.55-1,4.13s.33,2.93,1,4.12,1.58,2.1,2.75,2.74c1.16.64,2.47.96,3.92.96s2.76-.32,3.92-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.99,85.84l-4.95-8.04h-3.28v8.04h-2.72v-19.67h6.71c1.57,0,2.9.25,3.98.76,1.08.51,1.89,1.19,2.43,2.06.54.87.81,1.85.81,2.96,0,1.35-.41,2.55-1.24,3.58-.83,1.03-2.06,1.72-3.71,2.06l5.22,8.24h-3.25ZM238.76,75.73h4c1.47,0,2.58-.34,3.31-1.03.74-.69,1.1-1.6,1.1-2.75s-.36-2.07-1.09-2.71c-.73-.64-1.83-.96-3.33-.96h-4v7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.96,66.17l-6.77,12.25v7.42h-2.72v-7.42l-6.8-12.25h3.01l5.13,9.96,5.13-9.96h3.01Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo-full.cb3457a62e55077961ba7a9c9df41071.svg";
export { ForwardRef as ReactComponent };